import { CorrespondenceIssuedCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceIssuedCategory = createAction(
  '[CorrespondenceIssuedCategory] Load CorrespondenceIssuedCategory'
);

export const loadCorrespondenceIssuedCategorySuccess = createAction(
  '[CorrespondenceIssuedCategory] Load CorrespondenceIssuedCategory Success',
  props<{ correspondenceIssuedCategory: CorrespondenceIssuedCategoryDto[] }>()
);

export const loadCorrespondenceIssuedCategoryFailure = createAction(
  '[CorrespondenceIssuedCategory] Load CorrespondenceIssuedCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceIssuedCategory = createAction(
  '[CorrespondenceIssuedCategory] Add CorrespondenceIssuedCategory',
  props<{
    newCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[];
  }>()
);

export const addCorrespondenceIssuedCategorySuccess = createAction(
  '[CorrespondenceIssuedCategory] Add CorrespondenceIssuedCategory Success',
  props<{
    newCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[];
  }>()
);

export const addCorrespondenceIssuedCategoryFailure = createAction(
  '[CorrespondenceIssuedCategory] Add CorrespondenceIssuedCategory Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceIssuedCategory Collection Actions
 */
export const updateCorrespondenceIssuedCategory = createAction(
  '[CorrespondenceIssuedCategory] Update CorrespondenceIssuedCategory',
  props<{
    updateCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[];
  }>()
);

export const updateCorrespondenceIssuedCategorySuccess = createAction(
  '[CorrespondenceIssuedCategory] Update CorrespondenceIssuedCategory Success',
  props<{
    updateCorrespondenceIssuedCategory: CorrespondenceIssuedCategoryDto[];
  }>()
);

export const updateCorrespondenceIssuedCategoryFailure = createAction(
  '[CorrespondenceIssuedCategory] Update CorrespondenceIssuedCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceIssuedCategory Collection Actions
 */
export const removeCorrespondenceIssuedCategory = createAction(
  '[CorrespondenceIssuedCategory] Remove CorrespondenceIssuedCategory',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceIssuedCategorySuccess = createAction(
  '[CorrespondenceIssuedCategory] Remove CorrespondenceIssuedCategory Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceIssuedCategoryFailure = createAction(
  '[CorrespondenceIssuedCategory] Remove CorrespondenceIssuedCategory Failure',
  props<{ error: any }>()
);
